
'use client';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useForgotPasswordMutation } from "../../services/auth";
import { showError, showToast } from "../../helpers";
import { isValidInput } from "../../utils/validations";
import Input from '../../components/Input';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [forgotPasswordMutation, { isLoading }] = useForgotPasswordMutation();

    const formik = useFormik({
    initialValues: {
      email: '',
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .required('Email is required!')
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          'Enter a valid email address!',
        ),
    }),

    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        email: formik.values.email,
      };

      try {
        const response = await forgotPasswordMutation(body as any).unwrap();

        if (response?.statusCode === 200) {
          showToast(response?.message);
          navigate('/verify-otp', { state: body});
        }
      } catch (error: any) {
        showError(error?.data?.message || '');
        console.log(error);
      }
    },
  });

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please provide your email address to reset your password</p>

        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <Input
            placeholder="Email Address"
            name="email"
            id="email"
            isLoginField
            onChange={(val) => {
              if (isValidInput(val.target.value)) {
                formik.handleChange(val);
              }   
            }}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            helperText={formik.touched.email && formik.errors.email}
          />
          </div>

          <div className="form_btn">
            <Button
              className="btn btn_primary w_100"
            type="submit"
             disabled={isLoading}
            >
              Submit
            </Button>
          </div>
        </form>

        <div className="auth_bottom">
          <p>
            <button
              type="button"
              className="link"
              onClick={() => navigate("/")}
            >
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
